import React, { FC, useMemo } from "react";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useMultistepFormStore } from "@components/common/MultistepForm";
import { Stack } from "@components/base";

const NavigationControls: FC = () => {
  const { filteredSections, activeSection, nextSection, previousSection } =
    useMultistepFormStore();

  const sectionsLength = filteredSections.filter(
    (section) => section.isVisible,
  ).length;

  const activeSectionIndex = useMemo(
    () => filteredSections.findIndex((section) => section.id === activeSection?.id),
    [activeSection, filteredSections],
  );

  const handleNextStep = (): void => {
    nextSection();
  };

  const handlePreviousStep = (): void => {
    previousSection();
  };

  return (
    <Stack direction="row" spacing={2}>
      <IconButton
        disabled={activeSectionIndex === 0}
        onClick={handlePreviousStep}
        size="small"
        color="inherit"
      >
        <ArrowBackIcon />
      </IconButton>
      <IconButton
        disabled={activeSectionIndex === sectionsLength || sectionsLength <= 1}
        onClick={handleNextStep}
        size="small"
        color="inherit"
      >
        <ArrowForwardIcon />
      </IconButton>
    </Stack>
  );
};

export default NavigationControls;
